export default __webpack_public_path__ + "static/media/kitchen3-afterA-1440w.bc298c47.png";